<template>
  <div>
    <van-action-sheet
      v-model="show"
      :actions="actions"
      cancel-text="取消"
      :close-on-click-overlay="true"
      :close-on-click-action="true"
      @select="onSelect"
      @cancel="onCancel"
      @close="onCancel"
      :round="false"
    />
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="OperatorData"
        value-key="Text"
        @cancel="showPicker = false"
        @confirm="onConfirmOperator"
      />
    </van-popup>
  </div>
</template>

<script>
import { ActionSheet, Toast, Popup, Picker } from "vant";
import { ls } from "@/utils/cache.js";
import { mapState } from "vuex";
import roomApi from "../../../api/room.js";
import { getSelectData } from "@/api/common.js";
export default {
  name: "roomUpdate",
  components: {
    [ActionSheet.name]: ActionSheet,
    [Toast.name]: Toast,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
  },
  props: {
    option: {
      type: Object,
      default: () => {
        return {};
      },
    },
    visible: {
      type: Boolean,
      default: false,
    },
    fromUrl: {
      type: String,
      default: "",
    },
    defaultItem: {
      type: Object,
      default: () => {
        return {};
      },
    },
    update: {
      type: Function,
    },
  },
  computed: {
    show: {
      get() {
        this.renderActions();
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    ...mapState({
      user: state => state.user.info,
    }),
  },
  data() {
    return {
      actions: [
        {
          name: "解除维修",
          status: 1,
        },
        {
          name: "维修",
          status: 2,
          urlName: "RoomRepair",
        },
        { name: "置脏", status: 3 },
        { name: "清洁", status: 4 },
      ],
      showPicker: false,
      OperatorId: "",
      OperatorName: "",
      OperatorData: [],
      isClean: false,
      isUnRepair: false,
      RoomId: "",
      RoomNo: "",
      repairDate: [],
    };
  },
  created() {
    getSelectData({
      Types: "operater",
    }).then(res => {
      this.OperatorData = res.Data.operater;
    });
    this.RoomId = this.option.Id;
    this.RoomNo = this.option.No;
    this.OperatorId = this.user.OperatorId;
    this.OperatorName = this.user.OperatorName;
  },
  methods: {
    onConfirmOperator(data) {
      this.OperatorName = data.Text;
      this.OperatorId = data.Id;
      this.showPicker = false;
      if (this.isClean) {
        this.submitClean();
      } else if (this.isUnRepair) {
        this.submitUnRepair(this.RoomId, this.RoomNo, this.repairDate);
      }
    },
    submitClean() {
      roomApi
        .SetRoomClean({
          RoomId: this.option.Id,
          RoomNo: this.option.No,
          SetDirty: false,
          HandlerId: this.OperatorId,
          HandlerName: this.OperatorName,
        })
        .then(res => {
          Toast(res.Message);
          setTimeout(() => {
            this.$emit("update", { option: this.option, cleanStatus: 1 });
          }, 1000);
        });
    },
    submitUnRepair(Id, No, date) {
      let param = {
        RoomId: [Id],
        RoomNo: [No],
        SetDirty: true,
        HandlerId: this.OperatorId,
        HandlerName: this.OperatorName,
      };
      if (date && date.length) {
        param.RepairBeginTime = date[0];
        param.RepairEndTime = date[1];
      }
      roomApi.SetRepairEnd(param).then(res => {
        Toast(res.Message);
        setTimeout(() => {
          this.$emit("update", { roomStatus: 1 });
        }, 1000);
      });
    },
    renderActions() {
      let isLock = false;
      if (
        this.option.RoomStatusCalendarOutputs &&
        this.option.RoomStatusCalendarOutputs.length
      ) {
        const item = this.option.RoomStatusCalendarOutputs.find(
          el => el.FullDate == this.user.AccountDate,
        );

        if (item) {
          isLock = item.RoomStatus == 3;
        }
      }

      this.actions = [
        {
          name: "解除维修",
          status: 1,
          disabled: this.option.RoomStatus != 2,
        },
        {
          name: "维修",
          status: 2,
          urlName: "RoomRepair",
          disabled: this.option.RoomStatus == 2,
        },
        { name: "置脏", status: 3, disabled: this.option.RoomCleanStatus != 1 },
        { name: "清洁", status: 4, disabled: this.option.RoomCleanStatus == 1 },
        {
          name: "封房",
          status: 5,
          urlName: "RoomLock",
          disabled: isLock,
        },
        { name: "解除封房", status: 6, disabled: !isLock },
      ];
    },
    onCancel() {
      this.show = false;
      this.$emit("update:visible", false);
    },
    setUnRepair(Id, No, date) {
      this.RoomId = Id;
      this.RoomNo = No;
      if (date) {
        this.repairDate = date;
      }
      if (this.defaultItem.ChooseHandler == "1") {
        this.showPicker = true;
        this.isClean = false;
        this.isUnRepair = true;
      } else {
        this.submitUnRepair(Id, No, date);
      }
    },
    cancelLock(Id, No, daterange) {
      const params = {
        RoomId: [Id],
        RoomNo: [No],
        HandlerId: this.user.OperatorId,
        HandlerName: this.user.OperatorName,
      };
      if (daterange) {
        params.BeginTime = daterange[0];
        params.EndTime = daterange[1];
      }
      roomApi.setLockEnd(params).then(res => {
        Toast(res.Message);
        setTimeout(() => {
          this.$emit("update", { option: this.option });
        }, 1500);
      });
    },
    onSelect(item) {
      ls.set("current_room_info", { room: this.option, url: this.fromUrl });
      switch (item.status) {
        case 1:
          //解除维修
          this.repairDate = [];
          this.setUnRepair(this.option.Id, this.option.No);
          break;
        case 2:
          //维修
          this.$router.push({
            name: item.urlName,
          });
          break;
        case 3:
          //置脏
          roomApi
            .SetRoomClean({
              RoomId: this.option.Id,
              RoomNo: this.option.No,
              SetDirty: true,
              HandlerId: this.user.OperatorId,
              HandlerName: this.user.OperatorName,
            })
            .then(res => {
              Toast(res.Message);
              setTimeout(() => {
                this.$emit("update", { option: this.option, cleanStatus: 0 });
              }, 1500);
            });
          break;
        case 4:
          //清洁
          if (this.defaultItem.ChooseHandler == "1") {
            this.showPicker = true;
            this.isClean = true;
            this.isUnRepair = false;
          } else {
            this.submitClean();
          }

          break;
        case 5:
          //封房
          this.$router.push({
            name: item.urlName,
          });
          break;
        case 6:
          //解除封房
          this.cancelLock(this.option.Id, this.option.No);
          break;
        default:
          break;
      }
      this.show = false;
      this.$emit("update:visible", false);
    },
  },
};
</script>
